// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"104":"kindle","152":"device","486":"orders","985":"res"}[chunkId] + "." + {"104":"3cd79479","152":"4da1c269","486":"5714b1ea","985":"d4a4c6be"}[chunkId] + ".css";
};